import type { IconComponent } from '@change-corgi/design-system/icons';
import {
	iconChatBubble,
	iconEmail,
	iconFacebook,
	iconFacebookMessenger,
	iconGoogle,
	iconInstagram,
	iconIosShare,
	iconLine,
	iconLink,
	iconNextdoor,
	iconReddit,
	iconTwitter,
	iconVk,
	iconWhatsapp,
} from '@change-corgi/design-system/icons';
import type { ColorName } from '@change-corgi/design-system/theme';

import type { Channel } from '../../shared/types';

import type { FillableButtonChannel } from './types';

const COLORS: Record<Channel, ColorName> = {
	copy: 'social-copy',
	email: 'social-email',
	facebook: 'social-facebook',
	facebookMessenger: 'social-facebookMessenger',
	gmail: 'social-gmail',
	google: 'social-google',
	instagram: 'social-instagram',
	line: 'social-line',
	mobileNativeShare: 'social-iosShare',
	nextdoor: 'social-nextdoor',
	reddit: 'social-reddit',
	sms: 'social-sms',
	twitter: 'social-twitter',
	vk: 'social-vk',
	whatsapp: 'social-whatsapp',
};

export function getSocialColor(social: Channel): ColorName {
	return COLORS[social];
}

const ICONS: Record<Channel, IconComponent> = {
	copy: iconLink,
	email: iconEmail,
	facebook: iconFacebook,
	facebookMessenger: iconFacebookMessenger,
	gmail: iconGoogle,
	google: iconGoogle,
	instagram: iconInstagram,
	line: iconLine,
	mobileNativeShare: iconIosShare,
	nextdoor: iconNextdoor,
	reddit: iconReddit,
	sms: iconChatBubble,
	twitter: iconTwitter,
	vk: iconVk,
	whatsapp: iconWhatsapp,
};

export function getSocialIcon(social: Channel): IconComponent {
	return ICONS[social];
}

const FILLABLE_BUTTON_CHANNELS: Record<FillableButtonChannel, true> = {
	facebook: true,
	gmail: true,
};

export function isButtonFillable(social: Channel): boolean {
	return !!(FILLABLE_BUTTON_CHANNELS as Partial<Record<Channel, true>>)[social];
}
